import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { DocumentoDarCienciaList } from "../../../types/documento/darCiencia/DocumentoDarCienciaList";

const endpointUrl = configUrls.DOCUMENTO_EP

type Search = {
    id: string;
    search: string;
};

function getDocumentoCiencias({ id, search }: Search) {

    if (!id) {
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/ciencias/${id}?search=${search}`,
        method: "GET",
    }
}

function getDocumentoCienciaDada(id: string) {

    if (!id) {
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/ciencia/${id}`,
        method: "GET",
    }
}


function darCienciaDocumento({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/ciencia?id=${id}`,
        method: "POST",
    }
}

export const documentoCienciaApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getDocumentoCiencias: query<DocumentoDarCienciaList[], { id: string, search: string }>({
            query: getDocumentoCiencias,
            providesTags: ["Documento"],
        }),

        getDocumentoCienciaDada: query<boolean, string>({
            query: getDocumentoCienciaDada,
            providesTags: ["Documento"],
        }),

        darCienciaDocumento: mutation<void, { id: string }>({
            query: darCienciaDocumento,
            invalidatesTags: ["Documento"],
        }),
    }),
});

export const {
    useGetDocumentoCienciasQuery,
    useDarCienciaDocumentoMutation,
    useGetDocumentoCienciaDadaQuery,
    useLazyGetDocumentoCienciaDadaQuery,
} = documentoCienciaApiSlice